import React from 'react';
import './index.css';

function OutletHead({ left, right }) {

  return (
    <div className='outlet-head p-3'>
      <div className='row'>
        <div className='col d-flex align-items-center'>
          {left && left}
        </div>
        <div className='col'>
          <div className='right-block'>
            {
              right && right
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default OutletHead;
